// import React from "react";
// import Nuova from "../imgs/Nuova orchestra.png";
// import Orchestra from "../imgs/Nuova orchestra2.jpg";
// import VideoChiesa from "../video/Video-chiesa.mp4";

// const NuovaOrchestra = () => {
//   return (
//     <div className=" mb-4 px-2 flex flex-col items-center w-full bg-gradient-to-r from-white to-amber-50">
//       {/* Titolo */}
//       <p className="text-red-600 font-extrabold xs:text-2xl md:text-3xl ">
//         NUOVA ORCHESTRA DI MILANO
//       </p>

//       {/* Immagine introduttiva */}
//       <div className="gap-4 mb-8 flex flex-col md:flex-row items-center justify-center">
//         <img
//           className="xs:w-1/3 md:w-1/6 rounded-lg shadow-md"
//           src={Nuova}
//           alt="Nuova Orchestra"
//         />
//         <img
//           className="w-full md:w-1/2 rounded-lg shadow-md"
//           src={Orchestra}
//           alt="Orchestra"
//         />
//       </div>

//       {/* Video */}
//       <div className="w-full md:w-2/3 lg:w-1/2 mb-8">
//         <video
//           src={VideoChiesa}
//           muted
//           autoPlay
//           loop
//           className="w-full rounded-lg shadow-lg"
//         ></video>
//       </div>

//       {/* Sezione membri */}
//       <div className="flex flex-col items-center text-center text-gray-800 mb-10">
//         <p className="text-lg font-semibold mb-2">
//           Direttore:{" "}
//           <strong className="text-red-600">
//             <a
//               href="https://www.giuseppedinardo.it/"
//               className="hover:underline"
//               target="_blank"
//             >
//               Giuseppe Dinardo
//             </a>
//           </strong>
//         </p>

//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-base">
//           <div>
//             <strong className="font-extrabold">Violini</strong>
//             <p>
//               Lillia Bodnar, Valeria Bodnar, Luigi Russo, Erika Campisi,
//               Simonetta Sargenti, Anna Lombardi
//             </p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Viola</strong>
//             <p>Mariangela Franco Montelli</p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Violoncelli</strong>
//             <p>
//               Luca Russo Rossi, Maria Cristina Mancuso, Vincenzo Mocata, Sonia
//               Ilaria Maffioli
//             </p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Flauti</strong>
//             <p>Chiara Pasqualini, Samanta Rizzo, Andrea Cancellieri</p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Oboi</strong>
//             <p>Alessandro Nardi, Samuele Ballardini</p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Clarinetti</strong>
//             <p>Alessio Quaglia, Mario Montani</p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Fagotto</strong>
//             <p>Domenico Serrecchia</p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Corni</strong>
//             <p>Ana Abramovic, Antonio Bonatesta, Roberto Lonoce</p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Trombe</strong>
//             <p>Antonio Dinardo, Davide Scarafile, Angelo Maccarone</p>
//           </div>
//           <div>
//             <strong className="font-extrabold">Trombone</strong>
//             <p>Georghe Ciornei</p>
//           </div>
//         </div>
//       </div>

//       {/* Testo descrittivo */}
//       <div className="flex flex-col items-center text-center text-gray-700 space-y-6 px-4 md:px-10 lg:px-20">
//         <p>
//           In un periodo storico in cui diverse orchestre hanno dovuto chiudere i
//           battenti, MilARTE ha deciso di affrontare con determinazione questa
//           sfida culturale. L’orchestra trae ispirazione dalle prestigiose
//           formazioni internazionali e si configura come un autentico luogo di
//           aggregazione, concepito per celebrare la bellezza intrinseca nel "Fare
//           Musica". Al contempo, mira a promuovere la sensibilità verso i valori
//           dell'arte e dello spirito di gruppo sociale.
//         </p>
//         <p>
//           La <strong>Nuova Orchestra di Milano</strong> è dedicata
//           principalmente al mondo semiprofessionale e professionale, composto da
//           individui capaci di riconoscere la propria città e la propria
//           dimensione musicale come unico e valido punto creativo. Il suo
//           ambiente orchestrale offre uno spazio vitale per coltivare le passioni
//           legate alla comunicazione sociale, artistica e culturale. Rappresenta
//           un'opportunità senza pari per i musicisti che possiedono le competenze
//           per suonare uno strumento e desiderano continuare a farlo all'interno
//           di un contesto orchestrale.
//         </p>
//         <p>
//           Questo progetto, di innegabile valore culturale ed educativo, allinea
//           Milano a un modello di vita musicale improntato alla socializzazione,
//           corresponsabilità e creatività, tanto da aprirsi a collaborazioni con
//           altre città e realtà parallele sul territorio nazionale. La Nuova
//           Orchestra di Milano si configura altresì come un veicolo culturale e
//           promozionale, favorendo collaborazioni e interazioni socio-culturali
//           con università, teatri, musei, Conservatori e scuole di Musica.
//         </p>
//       </div>
//     </div>
//   );
// };

// export default NuovaOrchestra;

import React from "react";
import Nuova from "../imgs/Nuova orchestra.png";
import Orchestra from "../imgs/Nuova orchestra2.jpg";
import VideoChiesa from "../video/Video-chiesa.mp4";
import { FaMusic, FaUserTie } from "react-icons/fa";
import { GiMusicalNotes } from "react-icons/gi";

const NuovaOrchestra = () => {
  return (
    <div className="px-4 md:px-8 pb-16 flex flex-col items-center w-full bg-gradient-to-r from-white to-amber-50 text-gray-800">
      <GiMusicalNotes className="fixed text-amber-200/40 text-[180px] rotate-12 -top-5 -right-5 z-0" />

      {/* Titolo */}
      <h1 className="text-red-600 font-extrabold text-2xl md:text-4xl mt-5 tracking-wide mb-10 z-10">
        NUOVA ORCHESTRA DI MILANO
      </h1>

      {/* Sezione immagini */}
      <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-12 z-10">
        <img
          src={Nuova}
          alt="Nuova Orchestra"
          className="w-2/4 md:w-1/4 rounded-2xl shadow-md hover:scale-105 transition-transform duration-300"
        />
        <img
          src={Orchestra}
          alt="Orchestra"
          className="w-11/12 md:w-1/2 rounded-2xl shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Video */}
      <div className="w-full md:w-2/3 lg:w-1/2 mb-12  z-10">
        <video
          src={VideoChiesa}
          muted
          autoPlay
          loop
          className="w-full rounded-2xl shadow-lg border border-amber-200"
        ></video>
      </div>

      {/* Direttore */}
      <div className="flex flex-col items-center text-center bg-white rounded-2xl shadow-lg p-6 md:p-10 mb-12 w-full md:w-3/4 lg:w-2/3  z-10">
        <FaUserTie className="text-red-600 text-3xl mb-3" />
        <p className="text-xl font-semibold mb-2">
          Direttore:{" "}
          <a
            href="https://www.giuseppedinardo.it/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-red-600 hover:underline"
          >
            Giuseppe Dinardo
          </a>
        </p>
      </div>

      {/* Membri orchestra */}
      <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 w-full md:w-4/5 lg:w-2/3 mb-16  z-10">
        <div className="flex items-center justify-center mb-6">
          <FaMusic className="text-red-600 text-2xl mr-2" />
          <h2 className="text-2xl font-bold text-gray-900">
            Membri dell’Orchestra
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 text-base text-gray-700  ">
          {[
            [
              "Violini",
              "Lillia Bodnar, Valeria Bodnar, Luigi Russo, Erika Campisi, Simonetta Sargenti, Anna Lombardi",
            ],
            ["Viola", "Mariangela Franco Montelli"],
            [
              "Violoncelli",
              "Luca Russo Rossi, Maria Cristina Mancuso, Vincenzo Mocata, Sonia Ilaria Maffioli",
            ],
            ["Flauti", "Chiara Pasqualini, Samanta Rizzo, Andrea Cancellieri"],
            ["Oboi", "Alessandro Nardi, Samuele Ballardini"],
            ["Clarinetti", "Alessio Quaglia, Mario Montani"],
            ["Fagotto", "Domenico Serrecchia"],
            ["Corni", "Ana Abramovic, Antonio Bonatesta, Roberto Lonoce"],
            ["Trombe", "Antonio Dinardo, Davide Scarafile, Angelo Maccarone"],
            ["Trombone", "Georghe Ciornei"],
          ].map(([section, names], index) => (
            <div
              key={index}
              className="bg-amber-50 rounded-xl p-4 shadow-sm hover:shadow-md transition-all duration-300"
            >
              <strong className="font-extrabold text-red-600">{section}</strong>
              <p className="mt-1 text-gray-700">{names}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Testo descrittivo */}
      <div className="w-full md:w-4/5 lg:w-2/3 text-center text-gray-700 space-y-8 leading-relaxed bg-white/70 backdrop-blur-sm p-8 md:p-12 rounded-2xl shadow-md  z-10">
        <p>
          In un periodo storico in cui molte orchestre hanno dovuto chiudere i
          battenti, <strong>MilARTE</strong> ha deciso di affrontare con
          determinazione questa sfida culturale. L’orchestra si ispira alle
          prestigiose formazioni internazionali, diventando un luogo di
          aggregazione che celebra la bellezza del <em>“Fare Musica”</em> e
          promuove la sensibilità artistica e sociale.
        </p>
        <p>
          La <strong>Nuova Orchestra di Milano</strong> accoglie musicisti
          professionisti e semiprofessionisti che vogliono esprimere il proprio
          talento all’interno di un contesto orchestrale ricco di creatività e
          collaborazione. Un ambiente in cui le passioni musicali si uniscono
          alla crescita personale e artistica.
        </p>
        <p>
          Questo progetto, di grande valore culturale ed educativo, allinea
          Milano a un modello di vita musicale basato su socialità,
          corresponsabilità e innovazione, aprendosi a collaborazioni con altre
          città, università, teatri e scuole di musica.
        </p>
      </div>
    </div>
  );
};

export default NuovaOrchestra;
